import { CONSULTATION_COPY } from '../../../constants/consultation';

export const TEXTS = {
  loading: 'Loading practitioner profile...',
  notFound: {
    title: 'Practitioner Not Found',
    description: "We couldn't find the practitioner details. Please try again.",
    button: 'Back to Home',
  },
  hero: {
    bookConsultation: CONSULTATION_COPY.book,
    specialtiesLabel: 'Specialties:',
  },
  personalStory: {
    title: 'About the Name',
  },
  biography: {
    getTitle: (firstName) => `About ${firstName}`,
    subtitle: 'Get to know your certified hypnotherapist',
  },
  credentials: {
    title: 'Professional Credentials',
    education: 'Education',
    certifications: 'Certifications',
    memberships: 'Professional Memberships',
    practitionerTypes: 'Practitioner Types',
    languages: 'Languages Spoken',
    noData: 'No professional credentials available.',
  },
  contact: {
    title: 'Contact Information',
    email: 'Email:',
    phone: 'Phone:',
    address: 'Address:',
    visitWebsite: 'Visit Website',
    noData: 'Contact information coming soon.',
  },
};

export const CUSTOM_FIELD_IDS = {
  avatar: 'Uf5t1LoiYsc9z5teLXBr',
  fullBio: '5TMXInKVCGOH7ebdmGWJ',
  personalStory: 'xnRAkNyYWeXEiZQryrPV',
  specialties: '4VbTdvwhnXbJWflbnzbR',
  title: '6q2EnpHBpDn8XraVZGGQ',
  education: '72YvUv3uNIHc50dIRxxy',
  certifications: 'Bkz6IKYWZkWMbkvFsz5c',
  memberships: 'Ns1TYkFXMJi63m4RLrWS',
  practitionerTypes: 'Bkz6IKYWZkWMbkvFsz5c',
  languages: 'pW8Ln9ze5MK0ZZOHfAjF',
  instagram: 'wsiKmxX94iYdpazxoKMj',
  instagramAlt: 'wsiKmxX94iYdpazxoKMj',
  linkedin: 'XphtFHqlUsGxXUUjD8Rn',
  twitter: 'TI24X9e4rOPXUIRN8HvC',
  facebook: 'F3MBK5L489uU6vclaHfJ',
};
